<p matDialogContent>{{ data.tooltip }}</p>
<div matDialogActions class="dialog-actions">
  <button mat-stroked-button matDialogClose>RETOUR</button>
</div>
